import React from "react";
import "../css/PersonalEstablecimiento.css";

// ======================================
// PERSONAL DEL ESTABLECIMIENTO
// ======================================

const personal = [

    // ===============================
    // EQUIPO DOCENTE
    // ===============================

    {
        nombre: "Erika Órdenes Villarroel",
        cargo: "Profesora Jefe Pre-Kínder",
        correo: "eordenes@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Leslie Cristi Olavarría",
        cargo: "Técnico en Párvulos Pre-Kínder",
        correo: "lcristi@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Millaray Ramírez Mardones",
        cargo: "Profesora Jefe Kínder",
        correo: "mramirez@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Valeria Díaz Reyes",
        cargo: "Técnico en Párvulos Kínder",
        correo: "vfdiaz@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Alén Munay Briceño",
        cargo: "Profesora Jefe 1° Básico",
        correo: "abriceno@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Isaac Jiménez",
        cargo: "Profesor Jefe 2° Básico",
        correo: "ijimenez@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Pamela Andrea Jorquera",
        cargo: "Profesora Jefe 3° Básico",
        correo: "pjorquera@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Karin Alejandra Vergara Muñoz",
        cargo: "Profesora Jefe 4° Básico",
        correo: "kvergara@nzelandia.cl",
        area: "Primer Ciclo",
    },

    {
        nombre: "Luis Alberto Morales",
        cargo: "Profesor Jefe 5° Básico",
        correo: "lmorales@nzelandia.cl",
        area: "Segundo Ciclo",
    },

    {
        nombre: "Cristina Catalina Marín",
        cargo: "Profesora Jefe 6° Básico",
        correo: "cmarin@nzelandia.cl",
        area: "Segundo Ciclo",
    },

    {
        nombre: "Nicolás Jiménez",
        cargo: "Profesor Jefe 7° Básico",
        correo: "njimenez@nzelandia.cl",
        area: "Segundo Ciclo",
    },

    {
        nombre: "Claudia Andrea Guerra",
        cargo: "Profesora Jefe 8° Básico",
        correo: "cguerra@nzelandia.cl",
        area: "Segundo Ciclo",
    },

    // ===============================
    // PROFESORES POR ASIGNATURA
    // ===============================

    {
        nombre: "Claudia Alejandra Aracena",
        cargo: "Lenguaje",
        correo: "caracena@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    {
        nombre: "Claudia Andrea Guerra",
        cargo: "Historia",
        correo: "cguerra@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    {
        nombre: "Yenny Andrea Arriagada",
        cargo: "Inglés",
        correo: "yarriagada@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    {
        nombre: "Luis Alberto Morales",
        cargo: "Educación Física",
        correo: "lmorales@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    {
        nombre: "Nicolás André Jiménez",
        cargo: "Ciencias Naturales",
        correo: "njimenez@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    {
        nombre: "Cristina Catalina Marín",
        cargo: "Matemáticas",
        correo: "cmarin@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    {
        nombre: "Gregory Wilfredo Arias",
        cargo: "Música",
        correo: "garias@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    {
        nombre: "Sofía Martínez",
        cargo: "Danza",
        correo: "smartinez@nzelandia.cl",
        area: "Profesores por Asignatura",
    },

    // ===============================
    // APOYO EDUCATIVO
    // ===============================

    {
        nombre: "Karina Dalia Echeverría",
        cargo: "Coordinadora Centro de Innovación",
        correo: "kecheverria@nzelandia.cl",
        area: "Centro de Innovación",
    },

    {
        nombre: "Giovanni Mauricio Neira Valencia",
        cargo: "Encargado Centro de Innovación",
        correo: "gneira@nzelandia.cl",
        area: "Centro de Innovación",
    },

    {
        nombre: "Claudia Alejandra Aracena",
        cargo: "Coordinadora Biblioteca CRA",
        correo: "caracena@nzelandia.cl",
        area: "Biblioteca CRA",
    },

    {
        nombre: "Alejandra Flores Retamales",
        cargo: "Encargada CRA y Salud Escolar",
        correo: "axflores@nzelandia.cl",
        area: "Biblioteca CRA",
    },

    {
        nombre: "Katherina Paz Cifuentes",
        cargo: "Coordinadora P.I.E.",
        correo: "kcifuentes@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "Andrea Soledad Zirpel",
        cargo: "Fonoaudióloga",
        correo: "azirpel@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "Camila Pérez",
        cargo: "Fonoaudióloga",
        correo: "cperez@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "Yérica Guerrero",
        cargo: "Psicóloga",
        correo: "yguerrero@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "Julio Domínguez",
        cargo: "Terapeuta Ocupacional",
        correo: "jdominguez@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "Susana Rita Sasso",
        cargo: "Docente P.I.E.",
        correo: "ssasso@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "Pamela Denisse Vidal",
        cargo: "Docente P.I.E.",
        correo: "pvidal@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "María José Astorga",
        cargo: "Docente P.I.E.",
        correo: "mastorga@nzelandia.cl",
        area: "Equipo P.I.E.",
    },

    {
        nombre: "Cecilia Ethel Sánchez Vachy",
        cargo: "Docente P.I.E.",
        correo: "csanchez@nzelandia.cl",
        area: "Equipo P.I.E.",
    },


        // ===============================
    // GESTIÓN Y SERVICIOS
    // ===============================

    {
        nombre: "Marcia Silva Donoso",
        cargo: "Secretaría de Dirección",
        correo: "msilva@nzelandia.cl",
        area: "Administrativo",
    },

    {
        nombre: "María Alveal Carrasco",
        cargo: "Administrativa / Encargada PAE",
        correo: "malveal@nzelandia.cl",
        area: "Administrativo",
    },

    {
        nombre: "Leslie Cristi Olavarría",
        cargo: "Técnico en Párvulos",
        correo: "lcristi@nzelandia.cl",
        area: "Asistentes",
    },

    {
        nombre: "Valeria Díaz Reyes",
        cargo: "Técnico en Párvulos",
        correo: "vfdiaz@nzelandia.cl",
        area: "Asistentes",
    },

    {
        nombre: "Alejandra Flores Retamales",
        cargo: "Encargada CRA y Salud Escolar",
        correo: "axflores@nzelandia.cl",
        area: "Asistentes",
    },

    {
        nombre: "Giovanni Mauricio Neira Valencia",
        cargo: "Encargado Centro de Innovación",
        correo: "gneira@nzelandia.cl",
        area: "Asistentes",
    },

    {
        nombre: "Andrea Soledad Zirpel",
        cargo: "Fonoaudióloga",
        correo: "azirpel@nzelandia.cl",
        area: "Asistentes",
    },

    {
        nombre: "Miguel García Arroyo",
        cargo: "Nochero",
        correo: "mgarcia@nzelandia.cl",
        area: "Asistentes",
    },

    {
        nombre: "María Eugenia Olavarría Mardones",
        cargo: "Inspectora de Patio (Pre-Kínder a 2° Básico)",
        correo: "molavarria@nzelandia.cl",
        area: "Inspectoría",
    },

    {
        nombre: "Sandra Massone Arancibia",
        cargo: "Inspectora de Patio (3° a 5° Básico)",
        correo: "smassone@nzelandia.cl",
        area: "Inspectoría",
    },

    {
        nombre: "Jeannette Silva Manzo",
        cargo: "Inspectora de Patio (6° a 8° Básico)",
        correo: "jsilva@nzelandia.cl",
        area: "Inspectoría",
    },

    {
        nombre: "Nancy González Villalón",
        cargo: "Auxiliar de Servicios Menores",
        correo: "ngonzalez@nzelandia.cl",
        area: "Auxiliares",
    },

    {
        nombre: "Berta Parra Baeza",
        cargo: "Auxiliar de Servicios Menores",
        correo: "bparra@nzelandia.cl",
        area: "Auxiliares",
    },

    {
        nombre: "Yessenia Toro Pérez",
        cargo: "Auxiliar de Servicios Menores",
        correo: "ytoro@nzelandia.cl",
        area: "Auxiliares",
    },

    {
        nombre: "Eliana Espinoza Orellana",
        cargo: "Auxiliar de Servicios Menores",
        correo: "eespinoza@nzelandia.cl",
        area: "Auxiliares",
    },

    {
        nombre: "Paola Cornejo Taiba",
        cargo: "Auxiliar de Servicios Menores",
        correo: "pcornejo@nzelandia.cl",
        area: "Auxiliares",
    },

    {
        nombre: "Antonina Ulloa Córdova",
        cargo: "Auxiliar de Servicios Menores",
        correo: "aulloa@nzelandia.cl",
        area: "Auxiliares",
    },

    {
        nombre: "María Flores Sanhueza",
        cargo: "Auxiliar de Servicios Menores",
        correo: "mflores@nzelandia.cl",
        area: "Auxiliares",
    }

];

// ======================================

const grupos = [

    {
        titulo: "Equipo Docente",
        areas: [
            "Primer Ciclo",
            "Segundo Ciclo",
            "Profesores por Asignatura",
        ],
    },

    {
        titulo: "Apoyo Educativo",
        areas: [
            "Equipo P.I.E.",
            "Biblioteca CRA",
            "Centro de Innovación",
        ],
    },

    {
        titulo: "Gestión y Servicios",
        areas: [
            "Administrativo",
            "Inspectoría",
            "Asistentes",
            "Auxiliares",
        ],
    },

];

// ======================================

function PersonalEstablecimiento() {

    const obtenerPersonal = (area) =>
        personal.filter((persona) => persona.area === area);

    return (

        <section
            id="personal-establecimiento"
            className="esc-personal-section"
        >

            <div className="esc-personal-container">

                <div className="esc-personal-header">

                    <h2 className="esc-personal-title">
                         Personal del Establecimiento
                    </h2>

                    <p className="esc-personal-subtitle">
                         Conoce a las personas que forman parte de nuestra comunidad educativa y que,
                         con compromiso y vocación, trabajan diariamente para acompañar el aprendizaje,
                         bienestar y desarrollo integral de nuestros estudiantes.
                    </p>

                </div>


                {grupos.map((grupo) => (

                    <div
                        key={grupo.titulo}
                        className="esc-personal-group"
                    >

                        <h3 className="esc-personal-group-title">

                            {grupo.titulo}

                        </h3>

                        <div className="esc-personal-grid">

                            {grupo.areas.map((area) => (

                                <div
                                    key={area}
                                    className="esc-personal-card"
                                >

                                    <div className="esc-personal-card-header">

                                        {area}

                                    </div>

                                    <div className="esc-personal-card-body">

                                        {obtenerPersonal(area).map((persona, index) => (

                                            <div
                                                key={index}
                                                className="esc-personal-item"
                                            >

                                                <h4>

                                                    {persona.nombre}

                                                </h4>

                                                <p>

                                                    {persona.cargo}

                                                </p>

                                                <span>

                                                    {persona.correo}

                                                </span>

                                            </div>

                                        ))}

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                ))}

            </div>

        </section>

    );

}

export default PersonalEstablecimiento;